import { useEffect, useState } from 'react';
import React from 'react';
import './Emulator.css';
import { ReactComponent as BackArrow } from './back-arrow.svg';

import {ReactComponent as PlayButton} from './play.svg';
import {ReactComponent as PauseButton} from './pause.svg';
import {ReactComponent as PowerButton} from './power.svg';
import {ReactComponent as ResetButton} from './reset.svg';


const Emulator = ({ rom, setRom }) => {
    const [nes, setNes] = useState(null);

    useEffect(() => {
        let nesjs = window['nesjs'];
        let nesIns = nesjs({ video: { scale: 2 } });
        let fps = document.getElementById('fps');
        setNes(nesIns);
        setInterval(function () {
            fps.innerHTML = nesIns.running ? ('FPS: ' + ~~nesIns.fps) : '';
        }, 500);

        return () => {
            if (nes) nes.stop();
        }
    }, [])

    useEffect(() => {
        if (nes && rom) {
            nes.rom.load(rom).then(() => nes.start());
        }
    }, [nes, rom])

    return (
        <div className="Emulator__Page">
            <div className="Emulator__Header">
                <div className="Back__Button" onClick={() => { if (nes) nes.stop(); setRom(null) }}>
                    <BackArrow />
                </div>
            </div>
            <div>
                <div>
                    <canvas id="nesjs"></canvas>
                </div>
                <div className = {"controls"}>
                    <div className = {"control_buttons"} onClick={nes ? () => nes.start() : () => { }}><PlayButton  /></div>
                    <div className = {"control_buttons"} onClick={nes ? () => nes.stop()  : () => { }}><PauseButton /></div>
                    <div className = {"control_buttons"} onClick={nes ? () => nes.power() : () => { }}><PowerButton /></div>
                    <div className = {"control_buttons"} onClick={nes ? () => nes.reset() : () => { }}><ResetButton /></div>
                </div>
                <div id="fps"></div>
            </div>
        </div>
    );
}

export default Emulator;
